import api from 'clients/api/Api';

import { PrescricaoApiResponse, PrescricaoFilters } from 'domains/prescricao';

const getByCrm = async (crm: string, filters?: PrescricaoFilters) => {
  const normalizedCrm = parseInt(crm.replace(/[^0-9]/g, ''), 10);

  if (Number.isNaN(normalizedCrm)) {
    throw new Error('Invalid CRM format');
  }

  const { data } = await api.get<PrescricaoApiResponse>(`cardio/Prescricao/crm/${normalizedCrm}`, {
    params: filters,
  });

  return data;
};

export const PrescricaoService = { getByCrm };
